import { z } from 'zod/v4';

import { defaultPerPage } from './types';

export const paginationSchema = z.object({
  page: z
    .number()
    .gt(0)
    .or(
      z
        .string()
        .nonempty()
        .transform((value) => Number(value))
        .pipe(z.number().gt(0)),
    )
    .default(1),
  perPage: z
    .number()
    .gt(0)
    .or(
      z
        .string()
        .nonempty()
        .transform((value) => Number(value))
        .pipe(z.number().gt(0)),
    )
    .default(defaultPerPage),
});

export const paginationMetadataSchema = z.object({
  page: z.number(),
  perPage: z.number(),
  totalItems: z.number(),
  totalPages: z.number(),
});
